import React from "react";
import Header from "./Header";
import StopwatchContainer from "./StopwatchContainer";

// TODO - import localization file.

class App extends React.Component {
  render() {
    return (
      <div className="aap-stopwatch-app page">
        <Header />
        <div
          dangerouslySetInnerHTML={{
            __html: window["_stopwatchContextInfo"].aboveToolBlurb
          }}
        ></div>
        <StopwatchContainer />
        <div
          dangerouslySetInnerHTML={{
            __html: window["_stopwatchContextInfo"].belowToolBlurb
          }}
        ></div>
      </div>
    );
  }
}

export default App;
